import { render } from "./HContent.vue?vue&type=template&id=81e6a912&scoped=true"
const script = {}

import "./HContent.vue?vue&type=style&index=0&id=81e6a912&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e6a912"]])

export default __exports__